module.exports = __webpack_public_path__ + "img/www.lendingtree.com.5b2b1a0f.png";